const typeProcedure = (type) => {
  if ((type === 9) || (type === '9')) {
    return ('Horário Bloqueado')
  } else if ((type === 0) || (type === '0')) {
    return ('Primeira Consulta')
  } else if ((type === 1) || (type === '1')) {
    return ('Consulta')
  } else if ((type === 2) || (type === '2')) {
    return ('Exame')
  } else if ((type === 3) || (type === '3')) {
    return ('Retorno')
  } else if ((type === 4) || (type === '4')) {
    return ('Cirurgia')
  } else if ((type === 5) || (type === '5')) {
    return ('WEB')
  } else if ((type === 'C')) {
    return ('Compromisso')
  } else if ((type === undefined) || (type === null) || (type === '')) {
    return ('**Vago**')
  }
}

const iconClass = (type, status) => {
  if (status === 1) {
    return ('white white--text')
  } else if (status === 2) {
    return ('blue white--text')
  } else if (status === 3) {
    return ('red lighten-1 white--text')
  } else if (status === 4) {
    return ('blue lighten-1 white--text')
  } else if (status === 5) {
    return ('red lighten-1 white--text')
  } else if (status === 6) {
    return ('orange lighten-1 white--text')
  } else if (status === 11) {
    return ('red lighten-1 white--text')
  } else if ((status === null) || (type === null)) {
    return ('green white--text')
  } else if ((status === 'C')) {
    return ('orange lighten-1 white--text')
  }

  if ((status === 0) && (type === '9')) {
    return ('cyan darken-2 white--text')
  }
}

const typeStatusIcons = (type, status) => {
  if (status === 2) {
    return ('done')
  } else if (status === 0) {
    return ('https')
  } else if (status === 3) {
    return ('cancel_presentation')
  } else if (status === 4) {
    return ('done_all')
  } else if (status === 5) {
    return ('alarm')
  } else if (status === 6) {
    return ('watch')
  } else if (status === 8) {
    return ('arrow_right_alt')
  } else if (status === 11) {
    return ('block')
  } else if (status === null) {
    return ('tab_unselected')
  }

  // if (type === '9') {
  //   return ('enhanced_encryption')
  // } else if (type === '0') {
  //   return ('error')
  // } else if ((type === null) && (status === null)) {
  //   return ('tab_unselected')
  // } else if ((type === 'C')) {
  //   return ('notifications')
  // }
  // } else if (status === '1') {
  //   return ('done_all')
}

export default {
  typeProcedure,
  iconClass,
  typeStatusIcons
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/features.js